import { render, staticRenderFns } from "./TifCheckImage.vue?vue&type=template&id=16deb30a&"
import script from "./TifCheckImage.vue?vue&type=script&lang=js&"
export * from "./TifCheckImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports